import { ReactNode } from 'react'
import { useTranslation } from 'next-i18next/pages'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import SioLogoIcon from 'shared/icons/sio-logo-icon'
import { PUBLIC_LAYOUT_X_PADDING } from '../constants/public-layout-constants'
import { Menu } from './components/menu'
import SocialMedia from './components/social-media'

const PublicFooter = (): ReactNode => {
  const { t } = useTranslation()
  return (
    <div
      className={`pb-8 ${PUBLIC_LAYOUT_X_PADDING} flex flex-col gap-12 *:m-auto *:max-w-[1120px]`}
    >
      <div
        className={`flex w-full grid-cols-5 flex-wrap items-center justify-center gap-14 lg:grid`}
      >
        <LinkWithoutPrefetch
          href={'/'}
          className={`col-span-1 w-fit rounded-md outline-hidden focus-visible:focus-ring-primary`}
        >
          <SioLogoIcon className={'shrink-0 scale-105'} />
        </LinkWithoutPrefetch>
        <SocialMedia />
      </div>
      <div
        className={`grid grid-cols-2 gap-14 gap-y-8 font-mulish text-[16px] text-text-primary lg:grid-cols-4`}
      >
        <Menu />
        <span className={`col-span-2 flex justify-center lg:justify-start`}>
          {t('public.public_footer.systeme_rights')}
        </span>
      </div>
    </div>
  )
}

export default PublicFooter
